// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@rpsc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import { constants } from "@rpsc/XDL/constants";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.container = {
    gap: 16,
};

headerStyles.orderInfoGridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
        margin-bottom: 8px;
    `,
};
headerStyles.titleText = {
    variant: "h1",
    css: css`
        margin: 0;
    `,
};
headerStyles.orderNumberText = {
    variant: "h2",
    css: css`
        width: 100%;
    `,
};
headerStyles.orderPlacedText = {
    weight: fontConfig.weight.bold,
    size: 14,
    lineHeight: "19px",
    css: css`
        display: flex;
        max-width: 317px;
        flex-direction: column;
        flex: 1;
        gap: 8px;
        span {
            line-height: 22px;
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};

headerStyles.buttonsGridItem = {
    width: 12,
    css: css`
        gap: 12px;
        flex-wrap: wrap;
        align-items: center;
        ${xScreen("lte", constants.onePageCheckout.tablet)} {
            button {
                flex: 1;
                min-width: fit-content;
            }
        }
    `,
};

headerStyles.guestBox = {
    css: css`
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 12px;
        margin-top: 8px;
    `,
};

headerStyles.divider = {
    css: css`
        padding-bottom: 8px;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

headerStyles.guestBoxHeader = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

headerStyles.guestBoxAction = {
    css: css`
        width: fit-content;
        margin-top: 4px;
    `,
};

headerStyles.emailSentText = {
    size: 14,
    lineHeight: "22px",
};

headerStyles.printButton = {
    variant: "tertiary",
};
